(() => {
  // Generic dialog open/close (size chart etc.)
  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-cs-open]');
    if (opener) {
      const dlg = document.getElementById(opener.dataset.csOpen);
      if (dlg && typeof dlg.showModal === 'function') {
        if (dlg.parentElement !== document.body) document.body.appendChild(dlg); // escape sticky/transform containers
        dlg.showModal();
        document.documentElement.classList.add('cs-dialog-lock');
      }
      return;
    }
    if (e.target.closest('[data-cs-close]')) {
      e.target.closest('dialog')?.close();
      return;
    }
    if (e.target.tagName === 'DIALOG' && e.target.classList.contains('cs-dialog')) e.target.close(); // backdrop click
  });
  document.addEventListener('close', (e) => {
    if (e.target.classList?.contains('cs-dialog')) document.documentElement.classList.remove('cs-dialog-lock');
  }, true);

  if (!customElements.get('cs-size-chart')) {
    customElements.define('cs-size-chart', class extends HTMLElement {
      connectedCallback() {
        this.addEventListener('click', (e) => {
          const g = e.target.closest('[data-set-g]');
          const u = e.target.closest('[data-set-unit]');
          const p = e.target.closest('.cs-sc__pill');
          if (g) { this.dataset.g = g.dataset.setG; this.ensureCat(); }
          if (u) this.dataset.unit = u.dataset.setUnit;
          if (p) this.dataset.cat = p.dataset.cat;
          if (g || u || p) this.render();
        });
        this.ensureCat();
        this.render();
      }
      ensureCat() {
        if (!this.querySelector(`.cs-sc__panel[data-g="${this.dataset.g}"][data-cat="${this.dataset.cat}"]`)) {
          const first = this.querySelector(`.cs-sc__panel[data-g="${this.dataset.g}"]`);
          if (first) this.dataset.cat = first.dataset.cat;
        }
      }
      render() {
        const { g, cat, unit } = this.dataset;
        this.querySelectorAll('[data-set-g]').forEach((b) => b.classList.toggle('is-active', b.dataset.setG === g));
        this.querySelectorAll('[data-set-unit]').forEach((b) => b.classList.toggle('is-active', b.dataset.setUnit === unit));
        this.querySelectorAll('.cs-sc__pill').forEach((b) => {
          b.hidden = b.dataset.g !== g;
          b.classList.toggle('is-active', b.dataset.g === g && b.dataset.cat === cat);
        });
        this.querySelectorAll('.cs-sc__panel').forEach((pnl) => { pnl.hidden = !(pnl.dataset.g === g && pnl.dataset.cat === cat); });
      }
    });
  }
})();
